import { apiFetch } from './api';
import { requestWith } from './http';

/** Back-in-stock emails: guests confirm by email; signed-in requests join the wishlist. */
export interface StockAlertApi {
  subscribe(email: string, itemIds: readonly string[]): Promise<void>;
  confirm(token: string): Promise<{ confirmed: number }>;
  unsubscribe(token: string): Promise<void>;
}

export const stockAlertApi: StockAlertApi = {
  subscribe: (email, itemIds) =>
    requestWith(apiFetch, '/stock-alerts', {
      method: 'POST',
      json: { email, item_ids: itemIds },
      fallbackError: 'Could not save your request. Please try again.',
    }),
  confirm: (token) =>
    requestWith(apiFetch, `/stock-alerts/confirm?token=${encodeURIComponent(token)}`, {
      fallbackError: 'This confirmation link is invalid or has expired.',
    }),
  unsubscribe: (token) =>
    requestWith(apiFetch, '/stock-alerts/unsubscribe', {
      method: 'POST',
      json: { token },
      fallbackError: 'This unsubscribe link is invalid.',
    }),
};
